var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SVGInline-svg SVGInline--cleaned-svg SVG-svg BrandIcon-svg BrandIcon--size--32-svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F8",
    d: "M0 0h32v32H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi_jcb__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 24h4.4c1.001 0 2.2-1.194 2.2-2.133V8H7.2C6.199 8 5 9.195 5 11.2V24Z",
    fill: "#047AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.497 18.816A9.281 9.281 0 0 1 5 18.475v-1.173c.63.377 1.35.59 2.09.618.847 0 1.32-.576 1.32-1.365v-3.221h2.09v3.221c0 1.259-.682 2.261-3.003 2.261Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 24h4.4c1.001 0 2.2-1.194 2.2-2.133V8h-4.4c-1 0-2.2 1.195-2.2 3.2V24Z",
    fill: "#D42D06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 14.08c.638-.597 1.738-.97 3.52-.885.968.043 1.98.32 1.98.32v1.184a4.572 4.572 0 0 0-1.903-.608c-1.353-.117-2.178.619-2.178 1.91 0 1.29.825 2.026 2.178 1.92a4.639 4.639 0 0 0 1.903-.62v1.174s-1.012.288-1.98.33c-1.782.086-2.882-.287-3.52-.885v-3.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 24h4.4c1 0 2.2-1.194 2.2-2.133V8h-4.4c-1.001 0-2.2 1.195-2.2 3.2V24Z",
    fill: "#67B637"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9 17.28c0 .854-.682 1.387-1.595 1.387H20.4v-5.333h3.553l.253.01c.803.043 1.397.502 1.397 1.291 0 .619-.407 1.152-1.144 1.28v.032c.814.053 1.44.555 1.44 1.333Zm-2.805-3.104a1.036 1.036 0 0 0-.143-.01h-1.32v1.344h1.463c.275-.064.506-.31.506-.672 0-.363-.231-.608-.506-.662Zm-.011 2.166a.978.978 0 0 1 .176.01c.286.075.506.342.506.715 0 .373-.231.65-.506.715l-.176.021h-1.452v-1.461h1.452Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bi_jcb__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 8)",
    d: "M0 0h22v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeJcb);
export default __webpack_public_path__ + "static/media/stripe_jcb.cc8a64ae2d78adf4d92ab21c6c72e6d3.svg";
export { ForwardRef as ReactComponent };